import { baseUrl } from 'src/api/baseUrl';
import { async } from '@firebase/util';
import { makeAutoObservable, runInAction } from 'mobx';
import {
  CustomerAccountReport,
  CustomerAccountReportResult,
  ICustomer,
  ICustomerDetails,
  ICustomerForEdit,
  ICustomerParams,
} from 'src/@types/Choqorak/MainTables/Contract/Customer';
import agent from 'src/api/agent';

export default class Customertore {
  openDialog = false;

  //CustomerRegistry = new Map<number, ICustomer>();
  CustomerRegistry: ICustomer[] = [];

  editMode = false; //When click on edit button

  selectedCustomer: ICustomer | undefined = undefined;

  CustomerForEdit: ICustomerForEdit | undefined = undefined;

  SelectedCustomerDetail: ICustomerDetails | undefined;

  CustomerReportResult: CustomerAccountReportResult[] = [];

  totalRecord: number = 0;

  ID: any = localStorage.getItem('id');

  constructor() {
    makeAutoObservable(this);
  }

  get CustomerList() {
    return Array.from(this.CustomerRegistry.values());
  }

  setCustomerList = (Customer: ICustomer) => {
    this.CustomerRegistry.push(Customer);
  };

  //Pagination
  loadCustomer = async (params: ICustomerParams) => {
    try {
      const result = await agent.Customer.getList(params);
      runInAction(() => {
        this.totalRecord = result.data.totalRecord;
        if (params.pageIndex === 0) {
          this.CustomerRegistry = result.data.data.slice();
        } else {
          result.data.data.forEach((lst: any) => {
            this.setCustomerList(lst);
          });
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  loadCustomerDetail = async (id?: number) => {
  
      const axiosResponse = await agent.Customer.CustomerDetail(id);

      runInAction(() => {
        this.SelectedCustomerDetail = axiosResponse;
      });
    
  };

  loadCustomerAccountReport = async (reportParams: CustomerAccountReport) => {
    try {
      const axiosResponse = await agent.Customer.getCustomerAccountReport(reportParams);

      runInAction(() => {
        this.CustomerReportResult = axiosResponse.data;
      });
    } catch (error) {
      console.log(error);
    }
  };

  getCustomerForEdit = async (id: any) => {
    try {
      const result = await agent.Customer.getCustomerForEdit(id);
      const newData = { ...result.data, profilePhoto: baseUrl + result.data.photoPath };
      this.CustomerForEdit = newData;
      this.editMode = true;
    } catch (error) {
      console.log(error);
    }
  };

  // Search
  CustomerSearch = async (params: ICustomerParams) => {
    //this.CustomerRegistry.clear();
    this.loadCustomer(params);
  };

  getCustomerFromRegistry = (id: number) => {
    let Customer = this.CustomerRegistry.find((Customer) => Customer.customerId === id);
    localStorage.setItem('DetailsData', JSON.stringify(Customer));
    if (Customer) {
      this.editMode = true;
      this.selectedCustomer = Customer;
    }
  };

  clearSelectedCustomer = () => {
    this.editMode = false;
    this.CustomerForEdit = undefined;
    this.selectedCustomer = undefined;
  };

  deleteCustomer = async (id: number, remark?: string) => {
    await agent.Customer.delete(id, remark!);
    runInAction(() => {
      const index = this.CustomerRegistry.findIndex((Customer) => Customer.customerId === id);
      if (index !== -1) {
        this.CustomerRegistry.splice(index, 1);
        this.totalRecord--;
        this.setOpenCloseDialog();
      }
    });
  };

  setOpenCloseDialog = () => (this.openDialog = !this.openDialog);

  createCustomer = async (Customer: ICustomer) => {
    await agent.Customer.create(Customer, Customer.profilePhoto!).then((res) => {
      console.log(res);
    });

    runInAction(() => {
      this.loadCustomer({ pageIndex: 0, pageSize: 5 });
    });
  };

  updateCustomer = async (Customer: ICustomer) => {
    await agent.Customer.update(Customer, Customer.profilePhoto!);

    runInAction(() => {
      const index = this.CustomerRegistry.findIndex(
        (Customer) => Customer.customerId === Customer.customerId
      );
      if (index !== -1) {
        this.CustomerRegistry.splice(index, 1, Customer);
        this.loadCustomer({ pageIndex: 0, pageSize: 5 });
      }
    });
  };
}
